export const calculatorsData = [
  {
    id: 1,
    calculatorName: "What Is a Balance Transfer",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/What-credit-card-1738391819861.webp",
    link: "/calculators/financial-insights-and-tools/what-is-balance-transfer-blog",
  },
  {
    id: 2,
    calculatorName: "Personal Loan Balance Transfer with MinEMI",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-bt-loan-1738393201640.webp",
    link: "/calculators/financial-insights-and-tools/personal-loan-balance-transfer-blog",
  },
  {
    id: 3,
    calculatorName: "Home Loan Balance Transfer with MinEMI",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-1737028012223.webp",
    link: "/calculators/financial-insights-and-tools/home-loan-balance-transfer-blog",
  },
  {
    id: 4,
    calculatorName: "Car Loan Balance Transfer with MinEMI",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-bt-loan-1738393420849.webp",
    link: "/calculators/financial-insights-and-tools/car-loan-balance-transfer-blog",
  },
  // {
  //   id: 5,
  //   calculatorName: "Credit Card Balance Transfer Calculator",
  //   image: "./images/credit-card.webp",
  //   link: "/credit-card-balance-transfer-blog",
  // },
];
